import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { IForm } from "@/types";
import { useFormContext } from "react-hook-form";

interface Props {
    field: IForm["fields"][0];
    admin?: boolean; // Admin flag to handle field interaction
    setSelectedField?: (field: IForm["fields"][0]) => void; // Allow setting selected field
    value?: boolean; // Optional value prop
    className?: string;
}

export const CheckboxField = ({
    field,
    admin,
    setSelectedField,
    value,
    className,
}: Props) => {
    const formContext = useFormContext();
    const register = admin ? () => {} : formContext.register;
    const errors = admin ? {} : formContext.formState.errors;

    // Handle onCheckedChange for non-admin users
    const handleCheckedChange = (checked: boolean) => {
        if (!admin) {
            formContext.setValue(field.id, checked); // Update form value
        }
    };

    return (
        <div
            className={cn("flex w-full items-start gap-1", className)}
            onClick={() => {
                if (admin && setSelectedField) {
                    setSelectedField(field); // Open item when admin clicks
                }
            }}
        >
            <Checkbox
                {...(!admin ? register(field.id) : {})} // Register checkbox for non-admin users
                onCheckedChange={handleCheckedChange} // Handle change for non-admin users
                disabled={admin} // Disable checkbox interaction if admin
                checked={value} // Bind the value prop to the checkbox
                className="border-form-primary-color/20 data-[state=checked]:border-form-primary-color data-[state=checked]:bg-form-primary-color data-[state=checked]:text-form-primary-text-color"
            />
            <div className="flex flex-col gap-1">
                <Label
                    variant="toggle"
                    className="text-form-primary-text-color"
                >
                    {field.question || (
                        <span className="text-form-primary-text-color/70">
                            Question goes here...
                        </span>
                    )}
                    {field.required && (
                        <span className="text-form-primary-color">*</span>
                    )}
                </Label>
                {field.description && (
                    <Label
                        variant="subtoggle"
                        className="text-form-primary-text-color/70"
                    >
                        {field.description}
                    </Label>
                )}
            </div>

            {/* Validation Error Message (only for non-admin users) */}
            {!admin && errors?.[field.id] && (
                <p className="text-sm text-red-500">
                    {errors[field.id]?.message?.toString()}
                </p>
            )}
        </div>
    );
};
